(function(){
  // ==== KONFIG (EUR in CENT) – nutze deine vier Stufen ====
  const TIERS = [
    { threshold:    0,   label: "bis 19,99 €", benefit: "Versand 19,90 €" },
    { threshold:  2000,  label: "ab 20 €",     benefit: "Versand 14,90 €" },
    { threshold:  7000,  label: "ab 70 €",     benefit: "Versand 9,90 €"  },
    { threshold: 10000,  label: "ab 100 €",    benefit: "Versand 4,90 €"  },
    { threshold: 16000,  label: "ab 160 €",    benefit: "Versandfrei"     },
  ];

  const el = document.getElementById('ww-shipping-progress');
  if (!el) return;
  const elText = el.querySelector('.ww-sp__text');
  const elFill = el.querySelector('.ww-sp__fill');

  // -------- Utils
  const debounce = (fn, wait=150) => {
    let t; return (...args)=>{ clearTimeout(t); t = setTimeout(()=>fn.apply(this,args), wait); };
  };

  function money(cents){
    if (window?.Shopify?.formatMoney) {
      return Shopify.formatMoney(cents, "{{ shop.money_format | replace: '\"', '\\\"' }}");
    }
    return (cents/100).toLocaleString('de-DE', { style:'currency', currency:'EUR' });
  }

  function nextTierInfo(subtotal){
    for (let i=0;i<TIERS.length;i++){
      if (subtotal < TIERS[i].threshold) return { next: TIERS[i], index: i };
    }
    return { next: null, index: TIERS.length-1 };
  }

  function progressTo(target, subtotal){
    if (target <= 0) return 1;
    return Math.max(0, Math.min(1, subtotal/target));
  }

  // -------- Nachricht (mit aktuellen Versandkosten)
  function message(subtotal){
    // aktuelle Stufe
    let currentIndex = 0;
    for (let i=0;i<TIERS.length;i++){
      if (subtotal >= TIERS[i].threshold) currentIndex = i;
    }
    const current = TIERS[currentIndex];
    const nxt = nextTierInfo(subtotal).next;

    // aktuelle Versandkosten extrahieren
    let currentShipping = current?.benefit?.match(/\d+,\d+/)?.[0] + " €" || "0 €";
    if (/frei/i.test(current?.benefit)) currentShipping = "0 €";

    if (!nxt) {
      // Versandfrei erreicht
      return {
        text: `🎉 <b>Versandfrei gesichert!</b><br>Aktuelle Versandkosten: <b>${currentShipping}</b>.`,
        pct: 1
      };
    }

    const diff = nxt.threshold - subtotal;
    const pct  = progressTo(nxt.threshold, subtotal);

    // Versandkosten der nächsten Stufe
    let nextShipping = nxt?.benefit?.match(/\d+,\d+/)?.[0] + " €" || "0 €";
    if (/frei/i.test(nxt?.benefit)) nextShipping = "0 €";

    return {
      text: `Noch <b>${money(diff)}</b> bis zur nächsten Versandstufe <b>(${nextShipping})</b> – ` +
      `aktuell <b>${currentShipping}</b> Versandkosten.`,
      pct
    };
  }

  // -------- Cart-Handling
  async function fetchCart(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Cache-Control': 'no-cache' }});
      if (!res.ok) return null;
      return await res.json();
    }catch(e){ return null; }
  }

  const render = debounce(async function(){
    const cart = await fetchCart();
    if (!cart) return;
    if (cart.item_count === 0){
      el.hidden = true;
      return;
    }
    const subtotal = cart.items_subtotal_price; // Cent
    const { text, pct } = message(subtotal);
    elText.innerHTML = text;
    elFill.style.width = Math.round(pct*100) + '%';
    el.hidden = false;
  }, 80);

  // -------- Init
  document.addEventListener('DOMContentLoaded', render);

  // -------- Theme-Events (Dawn + Varianten)
  // Section/Editor Events
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('shopify:section:reorder', render);
  document.addEventListener('shopify:section:select', render);
  document.addEventListener('shopify:section:deselect', render);
  document.addEventListener('shopify:block:select', render);
  document.addEventListener('shopify:block:deselect', render);

  // Add-to-Cart Forms
  document.addEventListener('submit', (e)=>{
    const form = e.target;
    if (form && (form.matches('product-form') || form.matches('form[action^="/cart/add"]'))){
      setTimeout(render, 200);
      setTimeout(render, 900);
      setTimeout(render, 1600);
    }
  });

  // Häufig genutzte Custom Events
  document.addEventListener('cart:updated', render);
  document.addEventListener('cart-update', render);

  // PubSub (Dawn >=8)
  if (window.PubSub && typeof window.PubSub.subscribe === 'function'){
    try{
      window.PubSub.subscribe('cart-update', render);
      window.PubSub.subscribe('cart:updated', render);
      window.PubSub.subscribe('cart-error', render);
    }catch(_){}
  }

  // -------- Cart Drawer / Notification Beobachten
  function attachObservers(){
    const targets = [
      document.querySelector('cart-drawer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('.cart-notification')
    ].filter(Boolean);

    if (targets.length === 0) return;

    const mo = new MutationObserver(()=> render());
    targets.forEach(t => mo.observe(t, { childList:true, subtree:true, attributes:true, attributeFilter:['open','aria-hidden','class'] }));

    ['cart-drawer:open','cart-drawer:close','cart:refresh','cart:change'].forEach(evt=>{
      document.addEventListener(evt, render);
    });
  }

  // --- 1) Intercept fetch: Re-Render bei jedem Cart-Call
  (function hookFetchForWW(){
    if (window.__wwFetchHooked) return;
    window.__wwFetchHooked = true;

    const origFetch = window.fetch;
    window.fetch = async function(...args){
      const res = await origFetch.apply(this, args);
      try {
        const req = args[0];
        const url = typeof req === 'string' ? req : (req?.url || '');
        // Nur WRITE-Endpoints triggern Re-Render — /cart.js (read) NICHT, sonst entsteht eine Cascade.
        if (/\/cart\/(add|change|update)\.js(\?|$)/.test(url) && res.ok) {
          setTimeout(updateWeidewildShippingProgress, 60);
          setTimeout(updateWeidewildShippingProgress, 400);
          setTimeout(updateWeidewildShippingProgress, 1200);
        }
      } catch(_) {}
      return res;
    };
  })();

  // --- 2) Quantity-Änderungen im Cart (Seite + Drawer) abfangen
  document.addEventListener('change', (e)=>{
    if (
      e.target.matches('input[name="updates[]"]') ||
      e.target.closest('quantity-input') ||
      e.target.matches('input[type="number"][data-quantity-input]')
    ){
      setTimeout(updateWeidewildShippingProgress, 300);
      setTimeout(updateWeidewildShippingProgress, 1200);
    }
  });
  document.addEventListener('click', (e)=>{
    if (e.target.matches('quantity-input button') || e.target.closest('quantity-input button')){
      setTimeout(updateWeidewildShippingProgress, 300);
      setTimeout(updateWeidewildShippingProgress, 1200);
    }
  });

  // --- 3) MutationObserver: Cart-Container beobachten (Drawer + Seite)
  (function observeCartDom(){
    const targets = [
      document.querySelector('cart-drawer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('cart-items'),
      document.querySelector('form[action="/cart"]'),
      document.querySelector('.cart-notification')
    ].filter(Boolean);

    if (!targets.length) return;

    const mo = new MutationObserver(()=> {
      updateWeidewildShippingProgress();
    });
    targets.forEach(t => mo.observe(t, { childList:true, subtree:true, attributes:true }));
  })();

  // Drawer nachträglich erkennen
  document.addEventListener('DOMContentLoaded', ()=> {
    attachObservers();
    setTimeout(attachObservers, 800);
    setTimeout(attachObservers, 2000);
  });

  // -------- Manuell triggerbar
  window.updateWeidewildShippingProgress = render;
})();
